import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { PayInfoDetailProps } from "../PayInfoDetail";
import { PayDetailItem, PayDetailItemText } from "./PartyFeePay";

export default function LinkidMoneyCharge({ data }: PayInfoDetailProps) {
  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>링키드 머니</PayDetailItemText>
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.amount)}
        </PayDetailItemText>
      </PayDetailItem>
    </>
  );
}
